module.exports = __webpack_public_path__ + "img/aisn.3393d556.png";